import React from 'react';
import { Tooltip, Icon } from 'antd';
import PropTypes from 'prop-types';

const style = {
  container: {
    position: 'relative',
  },
  iconContainer: {
    position: 'absolute',
    top: 48,
    right: -18,
  },
};

const Info = ({ children, text, iconColor }) => (
  <div style={style.container}>
    {children}
    {text && (
      <div style={style.iconContainer}>
        <Tooltip title={text}>
          <Icon type="info-circle" style={{ color: iconColor }} />
        </Tooltip>
      </div>
    )}
  </div>
);

Info.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
  iconColor: PropTypes.string,
};

Info.defaultProps = {
  text: '',
  iconColor: '#1890ff',
};

export default Info;
